<template>
  <modal back="product-change" :title="title">
    <div>
      <menu-item
        v-for="(item, itemValue) in menuItems"
        :key="item.value"
        :collapsable="true"
        @collapsed="
          show =>
            trackFilter(show, item.value[0].toUpperCase() + item.value.slice(1))
        "
      >
        {{ $t(item.label) }}
        <span v-if="$store.getters.selectedCountByCategory(itemValue) > 0">
          ({{ $store.getters.selectedCountByCategory(itemValue) }})
        </span>
        <div slot="collapsable" class="block float-none p-2">
          <checkbox
            v-for="(filter, idx) of item.filters"
            :key="filter.value"
            v-model="item.filters[idx].selected"
            :label="filter.label"
            :value="item.filters[idx].value"
          />
        </div>
      </menu-item>
    </div>
    <div slot="footer">
      <div class="flex justify-between">
        <div class="w-2/5 p-2">
          <base-button color="link" @click.native="resetFilters">
            {{ $t('buttonLabel.resetFilters') }}
          </base-button>
        </div>
        <div class="w-2/5 p-2">
          <base-button @click.native="applyFilters">
            {{ $t('buttonLabel.applyFilters') }}
          </base-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../components/Modal.vue';
import MenuItem from '../../components/MenuItem.vue';
import Checkbox from '../../components/input/Checkbox.vue';
import { MUTATION_UPDATE_FILTERS } from '../../store/mutation-types';
import cloneDeep from 'lodash/cloneDeep';
import Redirect from '@/mixins/redirect';
import { TrackingMixin } from '../../mixins/gtm-tracking';

export default {
  name: 'FilterMenu',
  components: {
    Checkbox,
    MenuItem,
    Modal
  },
  mixins: [Redirect, TrackingMixin],
  data() {
    return {
      menuItems: cloneDeep(this.$store.state.filters)
    };
  },
  computed: {
    title() {
      const filterCount = this.$store.getters.filterCountTotal;
      return (
        this.$t('customization.filterProductLabel') +
        (filterCount > 0 ? ` (${filterCount})` : '')
      );
    }
  },
  methods: {
    trackFilter(show, itemLabel) {
      if (show) {
        this.trackPath({
          contentGroup1: 'Creator',
          contentGroup2: 'Creator_Product',
          contentGroup3: 'Creator_Filter' + itemLabel
        });
      }
    },
    applyFilters() {
      this.trackEvent({
        action: 'Product_Filter_Accept'
      });
      this.redirectAfter(
        () => this.$store.commit(MUTATION_UPDATE_FILTERS, this.menuItems),
        'product-change',
        'always'
      );
    },
    resetFilters() {
      Object.keys(this.menuItems).forEach(category => {
        Object.keys(this.menuItems[category].filters).forEach(filter => {
          this.menuItems[category].filters[filter].selected = false;
        });
      });
      this.applyFilters();
    }
  }
};
</script>
